import {
	Fab,
	FormControl,
	Grid,
	IconButton,
	Input,
	InputAdornment,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableRow,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import AttachmentIcon from '@material-ui/icons/Attachment';
import PublishIcon from '@material-ui/icons/Publish';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import MessageDialog from 'src/components/MessageDialog';
import { IMessage } from '../actions/message';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';

import SkillScenarioFactory, {
	ICertificationParam,
} from '../scenario/SkillScenarioFactory';
import Config from '../site.config.json';
const styles = () =>
	createStyles({
		cellItem1: {
			textAlign: 'right',
			width: '35%',
		},
		cellItem2: {
			width: '45%',
		},
		cellItem3: {
			textAlign: 'left',
			width: '20%',
		},
		paper: {
			overflowX: 'auto',
		},
		root: {
			flexGrow: 1,
			padding: 38,
		},
		table: {
			minWidth: '700px',
		},
	});

interface IState {
	uploadFile: File | null;
	uploadFileName: string;
	openErrorMessageDialog: boolean;
	openDialog: boolean;
	messages: IMessage[];
	certificationName: string;
	certificationExistFlg: boolean;
}

class CertificationFileUpload extends React.Component<IProps, IState> {
	protected uploadForm: HTMLFormElement | null;
	protected uploadInput: HTMLInputElement | null;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			certificationExistFlg: false,
			certificationName: '',
			messages: [],
			openDialog: false,
			openErrorMessageDialog: false,
			uploadFile: null,
			uploadFileName: '',
		};
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.handleDialogClose = this.handleDialogClose.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleUploadPre = this.handleUploadPre.bind(this);
	}

	public componentDidMount() {
		const param: ICertificationParam = {
			careerId: this.props.careerID,
			reasonCode: this.props.reasonCode,
			seq: this.props.seq,
			userId: this.props.userAttr.userId,
		};
		this.props
			.fetchCertificationInfo(this.props.token, param)
			.then(data => {
				const certificationExistFlg: boolean =
					data.certificationExistFlg;
				if (certificationExistFlg) {
					const certificationName: string =
						data.certificationFileName;
					this.setState({
						certificationExistFlg,
						certificationName,
					});
				}
				this.setState({
					certificationExistFlg,
				});
			});
	}

	public render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<Paper className={classes.paper}>
					<Table className={classes.table}>
						<TableBody>
							<TableRow>
								<TableCell className={classes.cellItem1}>
									<Grid
										item={true}
										style={{ fontSize: 'large' }}
									>
										{i18n.t('CertificationFileUpload_0001')}
									</Grid>
								</TableCell>
								<TableCell className={classes.cellItem2}>
									<Grid>
										<form
											method="POST"
											encType="multipart/form-data"
											action={
												Config.tsqPath +
												'/tsq/ui/common/resources/rest/file/upload'
											}
											ref={form =>
												(this.uploadForm = form)
											}
										>
											<FormControl>
												<Input
													type="text"
													value={
														this.state
															.uploadFileName
													}
													disabled={true}
													fullWidth={false}
													endAdornment={
														<InputAdornment position="end">
															<IconButton
																onClick={
																	this
																		.handleClickAttachment
																}
															>
																<AttachmentIcon />
															</IconButton>
														</InputAdornment>
													}
												/>
												{this.state
													.certificationExistFlg && (
													<Input
														type="text"
														value={
															this.state
																.certificationName
														}
														disabled={true}
														fullWidth={false}
													/>
												)}
												<input
													type="file"
													name="uploadFile"
													onChange={
														this.handleSelectFile
													}
													ref={input =>
														(this.uploadInput = input)
													}
													style={{
														display: 'none',
													}}
												/>
											</FormControl>
										</form>
									</Grid>
								</TableCell>
								<TableCell className={classes.cellItem3}>
									<Grid item={true}>
										<Fab
											color="primary"
											aria-label="Upload"
											onClick={this.handleUploadPre}
										>
											<PublishIcon />
										</Fab>
									</Grid>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</Paper>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('CertificationFileUpload_0002')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<MessageDialog
					open={this.state.openDialog}
					showCancelButton={true}
					title={i18n.t('CertificationFileUpload_0003')}
					contents={this.state.messages}
					onClose={this.handleDialogClose}
					onClickOk={this.handleUpload}
				/>
			</div>
		);
	}

	// 添付ボタン押下時ハンドラ
	protected handleClickAttachment = () => {
		if (!this.uploadInput) {
			return;
		}
		this.uploadInput.value = '';
		this.uploadInput.click();
	};

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({
			messages: [],
			openErrorMessageDialog: false,
			uploadFile: null,
			uploadFileName: '',
		});
	}

	protected handleDialogClose() {
		this.setState({
			messages: [],
			openDialog: false,
		});
	}

	// ファイル選択時のハンドラ
	protected handleSelectFile = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		if (!target.files || target.files.length === 0) {
			return;
		}
		const uploadFile = target.files[0];
		const uploadFileName = uploadFile.name;
		this.setState({
			uploadFile,
			uploadFileName,
		});
	};

	protected handleUploadPre() {
		if (!this.check()) {
			return;
		}
		if (this.state.certificationExistFlg) {
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'LMCM_E_15201',
				replacements: [],
			};
			messages.push(message);

			this.setState({
				messages,
				openDialog: true,
			});
		} else {
			this.handleUpload();
		}
	}

	protected handleUpload() {
		this.setState({
			openDialog: false,
		});
		let form = null;
		if (this.uploadForm) {
			form = new FormData(this.uploadForm);
			const modelData = {
				per_skill_RsltSKBlockCollection: {
					accessType: '10',
					careerID: this.props.careerID,
					certificationFileName: this.state.uploadFileName,
					classID: this.props.classID,
					reasonCode: this.props.reasonCode,
					seq: parseInt(this.props.seq, 10),
					userId: this.props.userAttr.userId,
				},
			};
			form.append('__modelData', JSON.stringify(modelData));
			const request = new XMLHttpRequest();
			request.open(
				'POST',
				Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
				true
			);
			request.setRequestHeader('Accept', 'application/json');
			request.send(form);
			request.onreadystatechange = () => {
				if (request.readyState === 4 && request.status === 200) {
					const errorModel = JSON.parse(request.responseText);
					let errorCode = '';
					let replacements: string[] = [];
					if (
						errorModel.per_skill_RsltSKBlockCollection !== undefined
					) {
						errorCode =
							errorModel.per_skill_RsltSKBlockCollection
								.errorCode;
						replacements =
							errorModel.per_skill_RsltSKBlockCollection
								.replacements;
					}
					if (errorModel.tsqErrorMessage !== undefined) {
						errorCode = errorModel.tsqErrorMessage[0].message;
						replacements = errorModel.tsqErrorMessage[0].strArray;
					}
					if (errorCode && errorCode !== '') {
						const messages: IMessage[] = [];
						const message: IMessage = {
							content: errorCode,
							replacements,
						};
						messages.push(message);
						this.setState({
							messages,
							openErrorMessageDialog: true,
						});
					} else {
						this.setState({
							uploadFile: null,
							uploadFileName: '',
						});
						this.componentDidMount();
					}
				}
			};
		}
	}

	protected check(): boolean {
		const messages: IMessage[] = [];

		if (!this.state.uploadFile) {
			const message: IMessage = {
				content: 'LMCM_E_15205',
				replacements: [],
			};
			messages.push(message);
		}

		if (this.state.uploadFile && this.state.uploadFile.size === 0) {
			const message: IMessage = {
				content: 'LMCM_E_00047',
				replacements: [],
			};
			messages.push(message);
		}

		if (
			this.state.uploadFile &&
			!/\.(pdf|jpg|jpeg|jpe|png)$/i.test(
				this.state.uploadFileName.toLowerCase()
			)
		) {
			const message: IMessage = {
				content: 'LMCM_E_15203',
				replacements: [],
			};
			messages.push(message);
		}

		if (this.state.uploadFile && this.state.uploadFileName.length > 128) {
			const message: IMessage = {
				content: 'LMCM_E_15204',
				replacements: ['128'],
			};
			messages.push(message);
		}

		// 表示
		if (messages.length !== 0) {
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
			return false;
		} else {
			return true;
		}
	}
}

const mapStateToProps = (state: IRootState) => ({
	dialogOpen: state.imstat.cancelApplication.dialogOpen,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCertificationInfo: (token: string, arg: ICertificationParam) => {
		const s = SkillScenarioFactory.createDoFetchCertificationInfo(
			dispatch,
			token
		);
		return s.run(arg);
	},
});

export interface ICertificationFileUploadProps {
	careerID: string;
	classID: string;
	reasonCode: string;
	seq: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICertificationFileUploadProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CertificationFileUpload);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/CertificationFileUpload.tsx